var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (query) {
buf.push("<div class=\"tt-suggestion empty-item\"><a class=\"mlsb-suggestion\"><span class=\"mlsb-suggestion-value\"><span class=\"mlsb-suggestion-display\">Search for &ldquo;" + (jade.escape((jade_interp = query) == null ? '' : jade_interp)) + "&rdquo;</span></span></a></div>");}.call(this,"query" in locals_for_with?locals_for_with.query:typeof query!=="undefined"?query:undefined));;return buf.join("");
};
module.exports = template;